import actionTypes from './actionTypes';
import initialState from './initialState';
import proofTypes from './components/proof-of-ownership/proofTypes';

const validate = state => {
    return state.userName.length > 0 &&
        state.password.length > 0 &&
        (
            (state.proofOfOwnershipType === proofTypes.CUSTOMER_NUMBER && state.proofOfOwnershipValue.length > 0) ||
            (state.proofOfOwnershipType === proofTypes.LAST_FOUR_CREDIT_CARD && state.proofOfOwnershipValue.length === 4)
        );
};

const reducer = (state = initialState, action) => {
    let nextState = null;
    switch (action.type) {

        case actionTypes.USERNAME_CHANGED:
            nextState = {
                ...state,
                userName: action.userName,
                userNameValid: action.userName.length >= 8
            };
            break;
        case actionTypes.PASSWORD_CHANGED:
            nextState = {
                ...state,
                password: action.password,
                passwordValid: action.password.length >= 8
            };
            break;
        case actionTypes.PROOF_OF_OWNERSHIP_TYPE_CHANGED:
            if (state.proofOfOwnershipType !== action.proofOfOwnershipType) {
                let value = state.proofOfOwnershipValue;
                if (action.proofOfOwnershipType === proofTypes.LAST_FOUR_CREDIT_CARD && value.length > 4) {
                    value = value.substring(0, 4);
                }
                nextState = {
                    ...state,
                    proofOfOwnershipType: action.proofOfOwnershipType,
                    proofOfOwnershipValue: value,
                    isShowRadioMobile: false
                };
            }
            break;
        case actionTypes.PROOF_OF_OWNERSHIP_VALUE_CHANGED:
            let value = action.proofOfOwnershipValue.trim();
            if (/^\d{0,}$/.test(value)) {
                if (state.proofOfOwnershipType === proofTypes.LAST_FOUR_CREDIT_CARD && value.length > 4) {
                    value = value.substring(0, 4);
                }
                else if (state.proofOfOwnershipType === proofTypes.CUSTOMER_NUMBER && value.length > 9) {
                    value = value.substring(0, 9);
                }
                nextState = {
                    ...state,
                    proofOfOwnershipValue: value
                };
            }
            break;
        case actionTypes.SUBMIT_IN_PROGRESS:
            nextState = {
                ...state,
                isProcessing: true,
                validationErrors: []
            };
            break;
        case actionTypes.SUBMIT_COMPLETED:
            nextState = {
                ...state,
                isProcessing: false
            };
            break;
        case actionTypes.AUTHORIZATION_COMPLETE:
            nextState = {
                ...state,
                isSubmitSuccessful: true,
                validationErrors: []
            };
            break;
        case actionTypes.AUTHORIZATION_FAILED:
            nextState = {
                ...state,
                isSubmitSuccessful: false,
                validationErrors: action.validationErrors
            };
            break;
        case actionTypes.NAVIGATE_BACK:
            nextState = {
                ...state,
                navigateBack: true
            };
            break;
        case actionTypes.SHOW_RADIO_MOBILE:
            nextState = {
                ...state,
                isShowRadioMobile: true
            };
            break;
        default:
            return state;
    }
    if (nextState !== null) {
        nextState.isFormComplete = validate(nextState);
        return nextState;
    }
    return state;
};

export default reducer;


// WEBPACK FOOTER //
// ./src/modules/account-connector/reducers.js